import api from './client';
let entity = 'tests';


export const create = async (entry) => {
  const { data } = await api.post(`/${entity}`, entry);
  return data;
};

export const getAll = async () => {
  const { data } = await api.get(`/${entity}`);
  return data;
};

export const deleteTest = async (id) => {
  const { data } = await api.delete(`/${entity}/${id}`);
  return data;
}


